import { render, staticRenderFns } from "./TeamMemberCard.vue?vue&type=template&id=7def2748&scoped=true&"
import script from "./TeamMemberCard.vue?vue&type=script&lang=js&"
export * from "./TeamMemberCard.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberCard.vue?vue&type=style&index=0&id=7def2748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7def2748",
  null
  
)

export default component.exports